(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-review-badges"] && !Shopify.designMode) return;
  try {
    (() => {
    // 同一页面多个页脚实例共享请求，避免重复访问后端。
    const requests = new Map();

    async function loadRatings(container) {
      const endpoint = container.dataset.apiUrl;
      if (!endpoint || container.dataset.reviewsInitialized) return;
      container.dataset.reviewsInitialized = 'true';

      try {
        let request = requests.get(endpoint);
        if (!request) {
          request = fetch(endpoint, { signal: AbortSignal.timeout(12000), credentials: 'omit' })
            .then(response => {
              if (!response.ok) throw new Error(`评分接口返回 HTTP ${response.status}`);
              return response.json();
            });
          requests.set(endpoint, request);
          request.catch(() => requests.delete(endpoint));
        }
        const result = await request;
        for (const badge of container.querySelectorAll('[data-review-platform]')) {
          const platform = badge.dataset.reviewPlatform;
          const data = result.platforms?.[platform];
          // 必须有成功获取时间和合法数字，失败时保留链接，不显示默认评分。
          if (!data || data.status !== 'ok' || !Number.isFinite(Date.parse(data.fetchedAt)) ||
              !Number.isFinite(data.rating) || data.rating < 0 || data.rating > 5 ||
              !Number.isInteger(data.reviewCount) || data.reviewCount < 0) continue;
          const rating = data.rating.toFixed(1);
          badge.querySelectorAll('[data-review-score]').forEach(node => { node.textContent = rating; });
          badge.querySelector('[data-review-count]').textContent = container.dataset.countLabel.replace('[count]', data.reviewCount.toLocaleString());
          badge.querySelector('[data-review-stars]').setAttribute('aria-label', container.dataset.ratingLabel.replace('[rating]', rating));
          // Trustpilot 图形使用半星档位，文字保留平台返回的精确分数。
          const stars = platform === 'trustpilot' ? Math.round(data.rating * 2) / 2 : data.rating;
          badge.querySelectorAll('.footer-review-badge__star').forEach((node, index) => {
            node.style.setProperty('--star-fill', `${Math.max(0, Math.min(100, (stars - index) * 100))}%`);
          });
          badge.querySelector('[data-review-rating]').hidden = false;
          badge.querySelector('[data-review-details]').hidden = false;
          badge.querySelector('[data-review-fallback]').hidden = true;
        }
      } catch (error) {
        console.warn('页脚评价：自动获取失败，保留平台评价链接。', error);
      }
    }

    function initialize(root) {
      root.querySelectorAll('[data-footer-reviews]').forEach(container => {
        if (!('IntersectionObserver' in window)) {
          loadRatings(container);
          return;
        }
        // 只在用户接近页脚时加载，避免影响首屏。
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            loadRatings(container);
          }
        }, { rootMargin: '200px' });
        observer.observe(container);
      });
    }

    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
